package com.islamicmedia.site.pages.isitsafe

import androidx.compose.runtime.Composable
import com.islamicmedia.site.components.PublicReviewPage
import com.varabyte.kobweb.core.Page

/** Public SEO review — "/isitsafe/paw-patrol". Pulls the REAL cached analysis from PROD. */
@Page("/isitsafe/paw-patrol")
@Composable
fun PawPatrolReviewPage() {
    PublicReviewPage(
        slug = "paw-patrol",
        blurb = "Is PAW Patrol OK for Muslim kids? Fitrah Filter checks shows, movies, and games against Islamic values. Here's the full breakdown for parents.",
    )
}
